import { useSyncExternalStore } from "react";
import SaveButton from "@/components/SaveButton";
import { RowSelectionStore } from "@/components/data-table/context/RowSelectionContext";

interface DefaultStoreProjectAssigneesCreatorSaveButtonProps {
  projectTypesStore: RowSelectionStore;
  storesStore: RowSelectionStore;
}

export const DefaultStoreProjectAssigneesCreatorSaveButton = ({
  projectTypesStore,
  storesStore,
}: DefaultStoreProjectAssigneesCreatorSaveButtonProps) => {
  const projectTypesCount = useSyncExternalStore(
    projectTypesStore.subscribe,
    projectTypesStore.getSelectionCount,
  );
  const storesCount = useSyncExternalStore(
    storesStore.subscribe,
    storesStore.getSelectionCount,
  );
  const hasSelections = projectTypesCount > 0 || storesCount > 0;

  return <SaveButton disabled={hasSelections ? false : undefined} />;
};
